import CrudActionSetBase from './CrudActionSetBase'

export class UserRoleActionSet extends CrudActionSetBase('userRole'){}
export default new UserRoleActionSet()